@use "@fukuri-admins/ui/layout" as *;

.container {
    &_Header {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .title {
        color: text('High');
        @include typography('Jp/20_W6');
    }
    .table {
        padding-top: spacing('20');
    }
}

.tableWrapper {
  margin-bottom: spacing("16");
}

.statusBadge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;

  &.inProgress {
    background-color: #FFF3CD;
    color: #856404;
  }

  &.completed {
    background-color: #D4EDDA;
    color: #155724;
  }
}
